// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_SyncChargeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/links/sync_charge/{charge_id}
 *
 * Returns sync details for a single provider charge. The nested result shape
 * comes from PaymentConfirmationService and is owned downstream.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_SyncChargeResponseDados = unknown[];

export type SubaccountsLinks_SyncChargeResponse = ApiResponse<SubaccountsLinks_SyncChargeResponseDados>;

registerResponseContract('SubaccountsLinks_SyncChargeResponse', {})
